import log from "loglevel";

// Set the desired log level (e.g., 'info', 'warn', 'error', etc.)
log.setLevel("error");

export default log;
